var _g, _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgricircleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 433.3 433.3",
    enableBackground: "new 0 0 433.3 433.3",
    xmlSpace: "preserve",
    width: 140,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -89.7464 216.6666)",
    fill: "#3F8361",
    cx: 216.7,
    cy: 216.7,
    rx: 216.7,
    ry: 216.7
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 216.7,
    y: 197.4,
    fill: "#F6F6F6",
    width: 8.7,
    height: 52.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M177,284.3c5.6,0,10.4-3.5,12-8.8h-4.3c-1,2.4-3.6,4.9-7.7,4.9c-4.9,0-8.5-3.8-8.5-8.7 c0-2.4,0.9-4.8,2.4-6.3c1.8-1.7,3.6-2.4,5.9-2.4l0.2,0c3.5,0,6.4,1.9,7.7,5.1h4.3c-1.5-5.4-6.4-8.9-12.2-8.9 c-7,0-12.5,5.5-12.5,12.6C164.3,277.8,168.8,284.3,177,284.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.4,
    y: 259.2,
    fill: "#F6F6F6",
    width: 4.2,
    height: 24.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M230,284.3c5.6,0,10.4-3.5,12-8.8h-4.3c-1,2.4-3.6,4.9-7.7,4.9c-4.9,0-8.5-3.8-8.5-8.7 c0-2.4,0.9-4.8,2.4-6.3c1.8-1.7,3.6-2.4,5.9-2.4l0.2,0c3.5,0,6.4,1.9,7.7,5.1h4.3c-1.5-5.4-6.4-8.9-12.2-8.9 c-7,0-12.5,5.5-12.5,12.6C217.3,277.8,221.7,284.3,230,284.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 246.6,
    y: 253.4,
    fill: "#F6F6F6",
    width: 4.2,
    height: 30.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M268,284.3c2.5,0,4.8-0.7,6.8-2c2-1.3,3.6-3.2,4.7-5.6l-4.3,0c-1.4,2.6-4,4.1-7.1,4.1 c-3.7,0-7.7-2.4-8.3-6.9l-0.1-0.9h20.8c0.3-4-0.9-7.6-3.6-10.3c-2.3-2.2-5.4-3.5-8.8-3.5c-7,0-12.5,5.6-12.5,12.6 C255.4,277.9,260.1,284.3,268,284.3z M259.8,268.8c0.6-3.1,3.6-6.2,8.2-6.2l0.1,0c4.4,0,7.4,3.2,8,6.2l0.2,1h-16.6L259.8,268.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M77.6,251.8c4.9,0,9.7-1.3,13.9-3.8l-4.5-7.2c-2.8,1.6-6.1,2.5-9.4,2.5c-10.3,0-18.6-8.4-18.6-18.6 c0-10.3,8.4-18.6,18.6-18.6c10.3,0,18.6,8.4,18.6,18.6v25.1h8.5v-25.1c0-15-12.2-27.1-27.1-27.1s-27.1,12.2-27.1,27.1 C50.5,239.6,62.7,251.8,77.6,251.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M143.4,271.3c8.1,0,16.1-3.5,20.9-9c4.1-4.7,5.9-10.1,5.9-18l0-19.9c0-15-12.2-27.1-27.1-27.1 s-27.1,12.2-27.1,27.1c0,15,12.2,27.1,27.1,27.1c4.9,0,9.7-1.3,13.9-3.8l-4.5-7.2c-2.8,1.6-6.1,2.5-9.4,2.5 c-10.3,0-18.6-8.4-18.6-18.6s8.4-18.6,18.6-18.6c10.3,0,18.6,8.4,18.6,18.6l0,21.7c0,0.8,0,1.6-0.1,2.4l0.2,0.3l-0.3,0.2 c-1.4,10-9.9,15.3-17.7,15.3c-1.1,0-5.2-0.2-9.1-2.8c-2.5-1.6-4.4-3.6-5.6-5.8h-10C121.4,263,129.1,271.3,143.4,271.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M208.2,205.7v-8.5c-14.5,0.5-26.2,12.5-26.2,27.1v25.6h8.5v-25.6C190.5,214.4,198.4,206.2,208.2,205.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M215.7,263.4v-4c-6.8,0.2-12.2,5.8-12.2,12.6v11.9h4v-11.9C207.5,267.3,211.2,263.5,215.7,263.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M354.3,232.1c-9.6,13.3-24.2,22-40.6,24.2c-32.9,4.4-63.3-18.7-67.7-51.6c-0.3-2.6-0.5-5.2-0.5-7.7h-8.1 c0,3.2,0.2,6.3,0.7,9.5c2.6,18,12,34,26.6,44.9c14.5,10.8,32.3,15.4,49.9,13.1c2.6-0.4,5.2-1,7.8-1.6c17.3-4.3,32.2-15.3,41.6-30.8 H354.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M349.3,168.4L349.3,168.4c-2.6-3.9-5.8-7.5-9.3-10.6c0.7-0.8,1.4-1.6,1.9-2.4c3.4-4.9,4.2-10,4.3-12.5l0-0.7 c0-0.1,0-0.2,0-0.4c0,0,0-0.1,0-0.1l0-26.4h0l0,0h-13.4c-20.5,0-29.9,15.7-29.9,30.3v10.5c-1.8-3-3.9-5.9-6.6-8.4 c-0.5-0.6-1.3-1.3-2.3-2.1c-1.9-1.7-3.9-3.2-5.9-4.6c-6.8-4.6-13.3-6.9-19.5-6.9h-14.1v8.1h0l0,21.2l0,0.4c0.1,4.4,1,13,5.5,21.3 c4.7,8.8,14.6,19.2,35,19.2l7.8,0l0,5.4l0.1,0h8.1v-38.9c13.2,2.4,22.7,14.6,21.4,28.3c-0.9,9.8-7.1,17.9-15.6,21.6 c-5.7,2.5-12.3,2.9-18.6,0.9c-5-1.6-9.3-4.7-12.5-8.8l-6.3,4.9c1.6,2,3.4,3.9,5.3,5.5c5.3,4.3,11.6,7.1,18.4,7.7 c6,0.6,11.8-0.5,17-2.8c0.3-0.1,0.6-0.3,1-0.4c0.1,0,0.2-0.1,0.2-0.1c8.1-3.9,14.7-10.9,17.7-20.1c5.3-16.2-2.1-33.6-16.8-41.2 c4.6-0.6,8.3-1.8,11.2-3.3c6.4,5.1,11.3,12.1,14,20.1c7.6,22.8-4.7,47.5-27.5,55.1c-14.4,4.8-29.9,1.8-41.3-7.5 c-9.8-8.1-15.8-20.4-15.8-33.7l-8,0c0,11.6,3.8,22.5,10.5,31.2l-0.1,0c2.5,3.2,5.2,6.1,8.3,8.6c4.7,3.9,10.1,7,16,9 c26.9,9.3,56.3-5,65.6-31.8C360.4,198.5,358.3,182,349.3,168.4z M302.8,190.8l0,5.5H295c-29.1,0-32.1-25-32.4-32.6 c0-0.1,0-0.1,0-0.2l0-21.1h6c8.3,0,16.4,6.2,20,9.4l0,0l2.1,1.9C303.7,165.7,302.8,190.5,302.8,190.8z M338.1,142.1 c0,1.3-0.4,6.5-4.3,10.5c-3.7,3.8-9.6,5.8-17.6,5.8h-5.1v-12.7c0-8.3,4.6-22.2,21.8-22.2h5.3L338.1,142.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgricircleLogo);
export default __webpack_public_path__ + "static/media/agricircle_logo.8dee7d2efcd8c0c0098ab46cd0ad6916.svg";
export { ForwardRef as ReactComponent };